import React from 'react';
import load from '../hocs/load';
import config from '../config';
import path from '../helpers/path';
var ProfileAndSettingsContainer = load(function () {
  return import('../layouts/ProfileAndSecurityLayout/ProfileAndSecurityLayout');
});
var KYCSettingsContainer = load(function () {
  return import('../components/KYCSettings');
});
var ApiKeysLayout = load(function () {
  return import('../layouts/ApikeysLayout/ApiKeysLayout');
});
var UserContactsLayout = load(function () {
  return import('../layouts/UserContactsLayout/UserContactsLayout');
});
var AffiliateContainer = load(function () {
  return import('../layouts/AffiliateLayout/AffiliateLayoutContainer');
});
var LoyaltyToken = load(function () {
  return import('../layouts/SettingsLayout/ChildrenLayouts/LoyaltyTokenLayout');
});
var TradeSettingsContainer = load(function () {
  return import('../components/Settings/TradeSettings');
});
var DemoSettingsContainer = load(function () {
  return import('../components/Settings/DemoSettings/DemoSettingsContainer');
});
var TradeReportLayout = load(function () {
  return import('../layouts/TradeReportLayout/TradeReportLayout');
});
var IBASettingsContainer = load(function () {
  return import('../components/Settings/InterestBearingAccounts/');
});

// this.context.t('Profile & Security')
// this.context.t('Verification Level')
// this.context.t('API Keys')
// this.context.t('Trade Reports')
// this.context.t('User Contacts')
// this.context.t('Affiliate Program')
// this.context.t('Loyalty Token')
// this.context.t('Demo Settings')
// this.context.t('Trade Settings')
// this.context.t('Yield Settings')
var _config$Settings = config.Settings,
  profile = _config$Settings.profile,
  apiKeys = _config$Settings.apiKeys,
  tradeReports = _config$Settings.tradeReports,
  userContacts = _config$Settings.userContacts,
  affiliate = _config$Settings.affiliate,
  loyaltyToken = _config$Settings.loyaltyToken,
  kyc = _config$Settings.kyc,
  tradeSettings = _config$Settings.tradeSettings,
  interestBearingAccountSettings = _config$Settings.interestBearingAccountSettings,
  demoMode = _config$Settings.demoMode;
export var settingsNavItems = [{
  text: 'Profile & Security',
  path: '/settings/profile',
  show: profile,
  icon: 'security'
}, {
  text: 'Trade Settings',
  path: '/settings/trade',
  show: tradeSettings,
  icon: 'tasks'
}, {
  text: 'Yield Settings',
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  icon: 'sell'
}, {
  text: 'Verification Level',
  path: '/settings/verification',
  show: kyc,
  icon: 'tasks'
}, {
  text: 'API Keys',
  path: '/settings/api-keys',
  show: apiKeys,
  icon: 'key'
}, {
  text: 'Trade Reports',
  path: '/settings/trade-reports',
  show: tradeReports,
  icon: 'reports'
}, {
  text: 'User Contacts',
  path: '/settings/contacts',
  show: userContacts,
  icon: 'contacts'
}, {
  text: 'Affiliate Program',
  path: '/settings/affiliate',
  show: affiliate,
  icon: 'friends'
}, {
  text: 'Loyalty Token',
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  icon: 'heart'
}, {
  text: 'Demo Settings',
  path: '/settings/demo-settings',
  show: demoMode,
  icon: 'paint'
}];
export var settingsRoutesArray = [{
  path: '/settings/profile',
  render: function render() {
    return React.createElement(ProfileAndSettingsContainer, null);
  }
}, {
  path: '/settings/trade',
  show: tradeSettings,
  render: function render() {
    return React.createElement(TradeSettingsContainer, null);
  }
}, {
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  render: function render() {
    return React.createElement(IBASettingsContainer, null);
  }
}, {
  path: '/settings/verification',
  render: function render() {
    return React.createElement(KYCSettingsContainer, null);
  }
}, {
  path: '/settings/api-keys',
  show: apiKeys,
  render: function render() {
    return React.createElement(ApiKeysLayout, null);
  }
}, {
  path: '/settings/trade-reports',
  show: tradeReports,
  render: function render() {
    return React.createElement(TradeReportLayout, null);
  }
}, {
  path: '/settings/contacts',
  show: userContacts,
  render: function render() {
    return React.createElement(UserContactsLayout, null);
  }
}, {
  path: '/settings/affiliate',
  show: affiliate,
  render: function render() {
    return React.createElement(AffiliateContainer, {
      route: '' + window.location.origin + path('') + '/signup?aff='
    });
  }
}, {
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  render: function render() {
    return React.createElement(LoyaltyToken, null);
  }
}, {
  path: '/settings/demo-settings',
  render: function render() {
    return React.createElement(DemoSettingsContainer, null);
  }
}];